import {
    PWA_INSTALL_PENDING_STORAGE_KEY,
    PWA_INSTALL_REPORTED_STORAGE_KEY_PREFIX,
} from '../constants';

export function getReportedStorageKey(userId: string): string {
    return `${PWA_INSTALL_REPORTED_STORAGE_KEY_PREFIX}${userId}`;
}

export function markInstallPending(storage: Storage = localStorage): void {
    storage.setItem(PWA_INSTALL_PENDING_STORAGE_KEY, '1');
}

export function clearInstallPending(storage: Storage = localStorage): void {
    storage.removeItem(PWA_INSTALL_PENDING_STORAGE_KEY);
}

export function isInstallPending(storage: Storage = localStorage): boolean {
    return storage.getItem(PWA_INSTALL_PENDING_STORAGE_KEY) === '1';
}

export function hasReportedInstall(userId: string, storage: Storage = localStorage): boolean {
    return storage.getItem(getReportedStorageKey(userId)) === '1';
}

export function markInstallReported(userId: string, storage: Storage = localStorage): void {
    storage.setItem(getReportedStorageKey(userId), '1');
    clearInstallPending(storage);
}

/**
 * Should we call the backend for this session?
 * True when the app looks installed and we have not yet recorded a successful report for this user.
 */
export function shouldReportPwaInstall(params: {
    userId: string | undefined;
    isStandalone: boolean;
    storage?: Storage;
}): boolean {
    const { userId, isStandalone, storage = localStorage } = params;
    if (!userId || !isStandalone) {
        return false;
    }
    if (hasReportedInstall(userId, storage)) {
        return false;
    }
    return true;
}
